<template>
  <div class="px-2 py-3" :style="titleOrDescriptionExist">
    <div class="scenario-title message-content-wrap" :style="isDescriptionValid">{{printTitle()}}</div>
    <div class="scenario-description message-content-wrap">{{printDescription()}}</div>
  </div>
</template>

<script>
import helper from 'util/helpers'
export default {
  name: 'scenario_item_text',
  props: [
    'title', 'description'
  ],
  computed: {
    titleOrDescriptionExist () {
      return helper.isStringValid(this.title) || helper.isStringValid(this.description) ? '' : 'height: 0px;'
    },
    isDescriptionValid () {
      return helper.isStringValid(this.description) ? 'margin-bottom: 10px' : 'margin-top: 10px'
    }
  },
  methods: {
    printTitle () {
      return this.title ? this.title : ''
    },
    printDescription () {
      return this.description ? this.description : ''
    }
  }
}
</script>

<style scoped>
  .scenario-title {
    width: 100%;
    font-size: 15px;
    font-weight: 600;
    line-height: 19px;
    color: #000000;
    margin-top: 5px;
  }
  .scenario-description {
    width: 100%;
    color: #3D5369;
    font-size: 14px;
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/scenario/item/scenario_item_text.vue